import type { GenericError, RequestStatus } from '@skynet/data-ws-core';

export enum TradingViewCommands {
  Chart = 'Chart',
}

export interface JsonChartSuccess {
  command: 'Chart';
  ticker: string;
  chart: JsonChartData[];
}

type JsonChartDataType = 'details' | 'candles';

type DateTimeString = string;

export interface JsonChartCandlesData {
  c: number;
  d: DateTimeString;
  h: number;
  l: number;
  o: number;
  v: string;
}

// type JsonChartDetailsData = string;

interface JsonChartData {
  type: JsonChartDataType;
  // data: JsonChartDetailsData[] | JsonChartCandlesData[];
  data: JsonChartCandlesData[];
}

export interface ChartCandlesData {
  time: DateTimeString;
  open: number;
  high: number;
  low: number;
  close: number;
  value: number;
}

export interface TradingViewState {
  data: ChartCandlesData[];
  status: RequestStatus;
  error: GenericError | null;
}

export enum TimeFrames {
  ONE_MIN = '1',
  FIVE_MIN = '5',
  FIFTEEN_MIN = '15',
  ONE_HOUR = '60',
  TWO_HOURS = '120',
  FOUR_HOURS = '240',
  ONE_DAY = 'D',
  ONE_WEEK = 'W',
  ONE_MONTH = 'M',
}
